

    import React,{Component} from 'react';
	// import Nav from './nav';
	// import About from './aboutUs';
	// import Contact from './contact';
	// import View from './viewer';
	// //import Btn from './button';
	import {Link} from 'react-router-dom';
	import axios from "axios";
	
	 
	class forgotPasswordComponent extends Component{
	
		constructor(props)
		{
			super(props)
			
			this.state = {
				tokenPresence: false,
				email: null,
				loading:false
			}
 
            this.submitHandler = this.submitHandler.bind(this);
            this.changeEmailHandler = this.changeEmailHandler.bind(this);

		}
	
	
        
        
        componentDidMount()
        {
           	
             //check for token and redirect to dashboard
				let accessToken = localStorage.getItem("token");
				if(accessToken !== "noToken")
				{
					if(accessToken !== null)
					{
					// alert(accessToken);
						this.setState({tokenPresence:true});
						this.props.history.push('/gitsearch/dashboard');
					}
					
				}
				
				

				if(accessToken !== null)
				{
					if(accessToken !== "noToken")
					{
					// alert(accessToken);
						this.setState({tokenPresence:true});
						this.props.history.push('/gitsearch/dashboard');
					}
					
				}
				
        }

        componentDidUpdate()
        {
           // alert("componentDidUpdate");
        }

        

        async submitHandler(e)
        {
			e.preventDefault();
			
			this.setState({loading:true});

			if((this.state.email !== null) && (this.state.email !== ""))
			{
				// make axios call to api
				try{

					let response  =  await axios.post("http://mofehintolumumuni.com/gitserver/api/forgot/password",{
                        email: this.state.email
                    },{"Content-type":"application/json"});

                    let status = response.data.status;
					let message = response.data.message;

					if(status === "success")
					{
						this.setState({loading:false});
						alert(`Action successful: ${message}`);
					}else
					{
						this.setState({loading:false});
						alert(`Action not successful: ${message}`);
					}

				}catch(error)
				{
					this.setState({loading:false});
					alert(`Action not successful,please try again`);
				}

			}
			else{
				this.setState({loading:false});
				alert("Please fill form properly before submitting");
			}
		
        }

        changeEmailHandler(e)
        {
            let formInput = e.target.value;
            this.setState({"email": formInput});
        }

       



	render()
	{
	return(
	
		<React.Fragment>
		<section>
		<div id="page-wrapper" className="sign-in-wrapper">
				<div className="graphs">
					<div className="sign-in-form">
                            <div className="sign-in-form-top">
							<h1>Password Reset <i className="fa fa-cogs"></i></h1>
							{(this.state.loading) ? <h3>Loading <i className="fa fa-cogs" ></i> </h3> : null}
						</div>
						<div className="signin">
						
							<form onSubmit={this.submitHandler} >
							<div className="log-input">
								<div className="log-input-left">
								   <input type="text" name="postemail" className="user" onChange={this.changeEmailHandler} placeholder="Enter Email" />
								</div>
								
								<div className="clearfix"> </div>
							</div>
							
                            <input type="submit" name="enter" value="Send" onclick="" id="passwreset" />
						</form>	 
						
							<div className="signin-rit">
						


						</div>
						</div>
						<div className="new_people">
							<h2 >New to gitSearch</h2>
							<p>Join the best free Github search tool today!</p>
							<Link to="/gitsearch/register">Register Now!</Link>
						</div>
					</div>
				</div>
			</div>
			</section>
</React.Fragment>

	);
	}


    }
    
    export default forgotPasswordComponent;


